import React from 'react';
import { motion } from 'framer-motion';
export const BrandStory = () => {
  return <section id="historia" className="scroll-mt-40 py-24 md:py-32 px-6 md:px-12 max-w-7xl mx-auto" data-id="element-18">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center" data-id="element-19">
        {/* Left: Copy */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="lg:col-span-5 flex flex-col" data-id="element-20">
          <span className="font-sans text-xs tracking-[0.2em] uppercase text-brand-charcoal/60 mb-4" data-id="element-21">
            El Estándar PinzColors
          </span>
          <h2 className="font-serif text-5xl md:text-6xl leading-tight text-brand-charcoal mb-8" data-id="element-22">
            Arte y cuidado en <br data-id="element-23" />
            <span className="italic" data-id="element-24">perfecta armonía.</span>
          </h2>
          <div className="space-y-6 text-brand-charcoal/80 font-light leading-relaxed" data-id="element-25">
            <p data-id="element-26">
              Creemos que el cuidado de tus manos es un ritual de amor propio.
              En PinzColors, no solo embellecemos tus uñas; protegemos su salud
              natural utilizando técnicas avanzadas y productos de la más alta
              calidad.
            </p>
            <p data-id="element-27">
              Cada servicio está diseñado para ofrecerte una durabilidad
              excepcional, una higiene impecable y un acabado que refleja tu
              estilo único. Tu bienestar y satisfacción son el lienzo sobre el
              que trabajamos.
            </p>
          </div>
        </motion.div>

        {/* Right: Image */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="lg:col-span-7 relative" data-id="element-28">
          <div className="rounded-[40px] md:rounded-[60px] overflow-hidden rotate-1 hover:rotate-0 transition-transform duration-700 shadow-[0_30px_70px_-20px_rgba(0,0,0,0.4)]" data-id="element-29">
            <img src="https://cdn.magicpatterns.com/uploads/rqV9QoLU5SKVpBmnA27Am7/esmalte_2.jpg" alt="Colección de esmaltes PinzColors" className="w-full h-auto aspect-[4/3] object-cover" data-id="element-30" />
          </div>
          {/* Decorative blur behind */}
          <div className="absolute -inset-10 bg-brand-cream/30 blur-3xl -z-10 rounded-full opacity-50" data-id="element-31" />
        </motion.div>
      </div>
    </section>;
};